export class CoupomCustomization {
  active_countdown: boolean;

  active_coupon: boolean;

  description: string;

  vtex_query: string;

  rules: string[];

  constructor(data: CoupomCustomization) {
    this.active_countdown = data.active_countdown;
    this.active_coupon = data.active_coupon;
    this.rules = data.rules || [];
    this.description = data.description;
    this.vtex_query = data.vtex_query;
  }
}
